import get from 'lodash.get';

import * as ODActions from '../../../store/orders/order-details/orders.details.actions';
import * as ReturnsActions from '../../../store/returns/returns.actions';
import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';

import * as Actions from './returns.nav.actions';

const VALID_TABS = ['outstanding', 'received', 'voided'];

const initialState = {
  selectedViewId: 'outstanding',
  searchData: {
    searchTerm: '',
  },
  searchPerformed: false,
};

const handleViewSearch = (state, action) => {
  if (!action.searchData) {
    return state;
  }
  return {
    ...state,
    searchData: action.searchData,
  };
};

const handleStatusCount = (state, { statusList }) => {
  const totalCount = statusList.reduce((sum, current) => sum + current.count, 0);
  const statusCountMap = statusList.reduce((countMap, current) => {
    return {
      ...countMap,
      [current.returnStatus.toLowerCase()]: current.count,
    };
  }, {});
  return {
    ...state,
    searchPerformed: true,
    count: totalCount,
    statusCountMap,
  };
};

const actionHandlerMap = {
  [Actions.RETURNS_CHANGE_VIEW]: (state, { viewId }) => {
    return {
      ...state,
      selectedViewId: viewId,
      previousViewId: state.selectedViewId,
    };
  },
  [Actions.RETURNS_SEARCH]: handleViewSearch,
  [Actions.RETURNS_SEARCH_SUCCESS]: handleStatusCount,
  [Actions.RETURNS_SEARCH_COUNT_SUCCESS]: handleStatusCount,
  [ReturnsActions.RETURNS_GRID_GET_RETURNS_SUCCESS]: (state) => {
    return {
      ...state,
      searchPerformed: false,
      count: undefined,
      statusCountMap: undefined,
    };
  },
  [ODActions.ORDER_DETAILS_MODAL_CLOSED]: (state) => {
    const selectedViewId = get(state, 'selectedViewId');
    const previousViewId = get(state, 'previousViewId');
    return {
      ...state,
      selectedViewId: VALID_TABS.indexOf(selectedViewId) > -1 ? selectedViewId : previousViewId,
    };
  },
  [Actions.CLEAR_SEARCH_INPUT]: (state) => {
    return {
      ...state,
      searchData: Object.assign({}, state.searchData, { searchTerm: '' }),
      searchPerformed: false,
      selected: false,
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './returns.nav.reducer.metadata';
